// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productMiniCardStyles } from "@guestsupply/App/Components/Product/ProductMiniCard";
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createLinkIconStyles, ellipsis } from "@guestsupply/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { css } from "styled-components";

productMiniCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 416px;
            border: none;
            padding: 0;
            & > .middle-section {
                height: 100%;
            }
            & > .bottom-section {
                height: auto;
            }
        `,
    },
    info: {
        css: css`
            padding: 0 0 4px;
            height: 100%;
            .product-description {
                display: flex;
                flex-direction: column;
                gap: 4px;
            }
        `,
    },
    image: {
        css: css`
            width: 90px;
            height: auto;
            max-height: 106px;
            margin: 0;
        `,
    },
    addToList: {
        css: css`
            justify-content: flex-end;
        `,
    },
};
productMiniCardStyles.availabilityyWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};
productMiniCardStyles.autoDeliveryWrapper = {
    css: css`
        height: 15px;
        display: flex;
        align-items: center;
        width: fit-content;
    `,
};
productMiniCardStyles.imageAndDescriptionSection = {
    css: css`
        display: flex;
        gap: 12px;
        height: 100%;
    `,
};

productMiniCardStyles.productImage = {
    linkWrappingImage: {
        css: css`
            &&& {
                width: 90px;
                height: 90px;
                img {
                    max-height: 100%;
                    max-width: 100%;
                    height: auto;
                }
            }
        `,
    },
    img: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
        `,
    },
};

productMiniCardStyles.productDescription = {
    ...createProductDescriptionStyles({
        productDetailDescription: {
            size: 12,
        },
        productDetailLink: {
            typographyProps: {
                size: 12,
            },
        },
    }),
};

productMiniCardStyles.productPartNumbersStyles = {
    container: {
        css: css`
            margin-top: 3px;
            flex-grow: 0;
        `,
    },
    erpNumberLabelText: {
        size: 12,
        weight: "bold",
        css: css`
            line-height: 15px;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    erpNumberValueText: {
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
};

productMiniCardStyles.productPriceStyles = {
    wrapper: {
        css: css`
            margin-top: auto;
        `,
    },
    price: {
        priceText: {
            size: 18,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 13,
            },
        },
    },
};

productMiniCardStyles.productActions = {
    addToCartContainer: {
        gap: 12,
    },
    addToCartButtonWrapper: {
        css: css`
            flex-grow: 1;
        `,
    },
};

productMiniCardStyles.productAddToListLinkStyles = {
    link: {
        ...createLinkIconStyles(Plus, {
            typographyProps: {
                size: 12,
                weight: "bold",
                css: css`
                    line-height: 12px;
                `,
            },
            icon: {
                position: "left",
                iconProps: {
                    size: 8,
                    color: "text.link",
                },
            },
        }),
    },
};
productMiniCardStyles.productAvailabilityStyle = {
    messageGridItem: {
        css: css`
            &&& {
                margin-bottom: 4px;
            }
            &:empty {
                display: none;
            }
        `,
    },
};
productMiniCardStyles.badgesWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 4px 8px;
        overflow: hidden;
        height: 48px;
    `,
};
